export const ActionRegulation = {
  ENFORCE: 'enforce',
  PREVENT: 'prevent',
  NONE: 'none'
};
